
class Loader {

	constructor () {
		this.opened = 0;
	}

	open () {
		this.opened++;
	}

	close () {
		this.opened--;
	}

	isOpened () {
		return !!this.opened;
	}

}

Loader.$inject = [];

export default angular.module('service.loader', [])
	.service('Loader', Loader)
	.name;



// WEBPACK FOOTER //
// ./src/service/loader.js